// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.YVndrKXAZpaYS4 {
  display: block;
  position: relative;
  width: 400px;
  overflow: hidden;
  border: 1px solid var(--ds-border, #091e4224);
  border-radius: 16px;
  opacity: 1;
  background-color: var(--ds-background-accent-gray-subtlest, #f1f2f4);
  -webkit-backdrop-filter: blur(0);
          backdrop-filter: blur(0);
}
.YVndrKXAZpaYS4.u6D7jseTl7ssjq {
  border: none;
}
.YVndrKXAZpaYS4.UzcoRXRuKNqplk {
  transition: flex 0.2s ease-in-out, opacity 0.2s ease-in, border-radius 0.2s ease-in-out, margin 0.2s ease-in-out, padding 0.2s ease-in-out;
}
@media (prefers-reduced-motion) {
  .YVndrKXAZpaYS4.UzcoRXRuKNqplk {
    transition: unset;
  }
}
.YVndrKXAZpaYS4.WuBUHwmtX5HiMS {
  flex: 1 1;
  margin-right: 6px;
}
.YVndrKXAZpaYS4:not(.anBkkAICPUrHfU):not(._IrnR6atJZ387o):not(.YDZ3_1aXAdWP47):first-of-type {
  margin-left: 6px;
}
.YVndrKXAZpaYS4:not(.anBkkAICPUrHfU):not(._IrnR6atJZ387o):not(.YDZ3_1aXAdWP47):last-of-type {
  margin-right: 6px;
}
.YVndrKXAZpaYS4._IrnR6atJZ387o {
  flex-grow: 1;
  margin: 0;
  border: unset;
  border-radius: 0;
}
.YVndrKXAZpaYS4.YDZ3_1aXAdWP47 {
  width: 0px;
  margin: 0;
  opacity: 0;
}
@media print {
  .YVndrKXAZpaYS4 {
    width: 100%;
    overflow: visible;
  }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"panel": `YVndrKXAZpaYS4`,
	"collapsed": `u6D7jseTl7ssjq`,
	"panelTransitions": `UzcoRXRuKNqplk`,
	"rightmostPanel": `WuBUHwmtX5HiMS`,
	"noDividers": `anBkkAICPUrHfU`,
	"singlePanel": `_IrnR6atJZ387o`,
	"hidden": `YDZ3_1aXAdWP47`
};
export default ___CSS_LOADER_EXPORT___;
